module.exports = __webpack_public_path__ + "img/bulb.180e7050.png";